import { render } from "./OrdersIndexTable.vue?vue&type=template&id=8ded40b2"
import script from "./OrdersIndexTable.vue?vue&type=script&lang=js"
export * from "./OrdersIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__